const STORAGE_KEY = "posture_loop_notification_delivery"

export const DELIVERY_VERIFIED = "verified"
export const DELIVERY_FAILED = "failed"

export function readDeliveryState() {
  return localStorage.getItem(STORAGE_KEY)
}

export function markDeliveryVerified() {
  localStorage.setItem(STORAGE_KEY, DELIVERY_VERIFIED)
}

export function markDeliveryFailed() {
  localStorage.setItem(STORAGE_KEY, DELIVERY_FAILED)
}

export function clearDeliveryState() {
  localStorage.removeItem(STORAGE_KEY)
}

export function isMacOS() {
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform) ||
    navigator.userAgent.includes("Mac OS")
}

export function browserLabel() {
  if (typeof navigator.brave !== "undefined") return "Brave"
  if (navigator.userAgent.includes("Edg/")) return "Microsoft Edge"
  if (navigator.userAgent.includes("Firefox/")) return "Firefox"
  if (navigator.userAgent.includes("Chrome/")) return "Google Chrome"
  if (navigator.userAgent.includes("Safari/")) return "Safari"
  return "your browser"
}

export function sitePermissionGranted() {
  return "Notification" in window && Notification.permission === "granted"
}

export function deliveryFailureIntro() {
  return "This site is allowed to send notifications, but nothing appeared on screen. " +
    "Your operating system is probably blocking banners from your browser — check the steps below."
}

export function osNotificationSteps() {
  const browser = browserLabel()

  if (isMacOS()) {
    return [
      `Open System Settings → Notifications → ${browser}`,
      "Turn on Allow Notifications",
      "Choose Banners or Alerts (not “None” or Notification Center only)",
      "Turn off Focus and Do Not Disturb",
      "Switch to another tab and wait for the next activity to end"
    ]
  }

  if (/Windows/i.test(navigator.userAgent)) {
    return [
      "Open Settings → System → Notifications",
      `Find ${browser} and turn notifications on`,
      "Allow banners or toasts (not silent or priority list only)",
      "Turn off Focus assist / Do Not Disturb",
      "Switch to another tab and wait for the next activity to end"
    ]
  }

  return [
    "Open your system notification settings",
    `Allow ${browser} to show banners or toasts`,
    "Turn off Do Not Disturb or Focus mode if enabled",
    "Switch to another tab and wait for the next activity to end"
  ]
}
